/* Shared options for job openings sidebar filter lists. */
/* Provides the terms list, selection get/set, sorted options, and the */
/* toggle handler that fires the analytics event. Implementing components */
/* must define analyticsEventName(key) to produce the per-component event id. */

import analytics from 'Scripts/analytics';

import { sortTerms, setFilter } from '../helpers/postings.js';

const filterMixin = {
	props: {
		/* Name of the taxonomy we're selecting for */
		taxonomy: {
			type: String,
			required: true,
		},
	},

	computed: {
		/* List of available terms */
		terms() {
			return this.$store[this.taxonomy] || {};
		},

		/* Current selection */
		selection: {
			get() {
				return this.$store.filter[this.taxonomy] || [];
			},
			set(value) {
				setFilter(this.$store, value, this.taxonomy);
			},
		},

		/* Available options, sorted for this taxonomy */
		options() {
			return Object.entries(this.terms)
				.map(([key, term]) => ({ key, term }))
				.sort((a, b) => sortTerms(this.taxonomy, a, b));
		},
	},

	methods: {
		/* Toggle a key in the selection and emit a tracking event */
		toggleSelection(key) {
			if (this.selection.includes(key)) {
				this.trackSelection(key, 'deselect');
				this.selection = this.selection.filter(existing => existing !== key);
			} else {
				this.trackSelection(key, 'select');
				this.selection = [...this.selection, key];
			}
		},

		/* Fire the analytics event using the component-supplied name */
		trackSelection(key, type) {
			analytics.trackAnalyticsEvent(type, 'click', this.analyticsEventName(key));
		},
	},
};

export default filterMixin;
